import React, { useContext } from 'react';
import { Col, Button, OverlayTrigger, Popover, Tooltip, Badge } from 'react-bootstrap';
import Logo from '../Logo/Logo';
import game from '../../util/game.util';
import { StarFill, Check, ArrowBarLeft, Display, ArrowClockwise, Share, ListStars } from 'react-bootstrap-icons';
import { GameContext } from '../../context/game.context';
import LinkButton from '../LinkButton/LinkButton';
import Pie from '../Pie/Pie';
import {
    EmailShareButton,
    FacebookShareButton,
    RedditShareButton,
    TwitterShareButton,
} from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    RedditIcon,
    TwitterIcon,
} from "react-share";

const Results = props => {
    const gameContext = useContext(GameContext);
    const save = gameContext.save;

    const topic = props.match.params.topic;

    const url = 'https://unifiedus.org';
    const quote = 'Did you know Americans agree on more than you might think, play the game to test your knowledge!';
    const hashtag = '#ReunifyGame';

    const averages = save[topic].answers.reduce((previousValue, currentValue) => {
        return {
            youAgree: previousValue.youAgree + currentValue.youAgree,
            americansAgree: previousValue.americansAgree + currentValue.americansAgree,
            democratsAgree: previousValue.democratsAgree + currentValue.democratsAgree,
            republicansAgree: previousValue.republicansAgree + currentValue.republicansAgree,
        }
    });
    averages.youAgree /= save[topic].answers.length / 100;
    averages.americansAgree /= save[topic].answers.length;
    averages.democratsAgree /= save[topic].answers.length;
    averages.republicansAgree /= save[topic].answers.length;

    console.log(averages.youAgree)

    const questionavg = game[topic].questions.reduce((previousValue, currentValue) => {
        return {
            americansAgree: previousValue.americansAgree + currentValue.americansAgree,
            democratsAgree: previousValue.democratsAgree + currentValue.democratsAgree,
            republicansAgree: previousValue.republicansAgree + currentValue.republicansAgree,
        }
    });
    questionavg.americansAgree /= game[topic].questions.length;
    questionavg.democratsAgree /= game[topic].questions.length;
    questionavg.republicansAgree /= game[topic].questions.length;

    console.log('averages', averages);
    console.log('questionavg', questionavg);

    const americansDiff = questionavg.americansAgree - averages.americansAgree;
    const democratsDiff = questionavg.democratsAgree - averages.democratsAgree;
    const republicansDiff = questionavg.republicansAgree - averages.republicansAgree;

    function formatPercent(percent) {
        return `${Math.abs(parseFloat(percent.toFixed(2)))}%`;
    }

    return (
        <>
            <Col lg="6" sm className='p-3'>
                <Logo />
                <LinkButton to="/" variant="light" className="mb-3"><ArrowBarLeft />Back</LinkButton>
                {/* <div className="question-icon">{game[topic].icon}</div> */}
                <h1 className="text-center">{topic}</h1>
                <h5 className='question-progress'>
                    <Badge
                        bg="light"
                        pill
                        className="mx-auto d-block mb-3"
                    >
                        Results
                    </Badge>
                </h5>
                <br />

                {/* <p style={{ color: 'red' }}>The copy on this page is placeholder.</p> */}
                <div className='quote-container'>
                    <h2 className="text-center">Thanks for playing</h2>
                    <p>Turns out Americans agree more than we think.<br />Ready to try another topic or share the game and see how your friends score?</p>
                </div>
                <ul className="results-list mt-5">
                    <li><strong>You agreed {formatPercent(averages.youAgree)}</strong> of the time on issues related to {topic}, compared to <span className="highlight-info">{formatPercent(questionavg.americansAgree)} of Americans</span>, <span className="highlight-primary">{formatPercent(questionavg.democratsAgree)} of Democrats</span> and <span className="highlight-secondary">{formatPercent(questionavg.republicansAgree)} of Republicans</span>.</li>
                    <li>On average <span className="highlight-info">Americans agree {formatPercent(americansDiff)} {americansDiff > 0 ? 'more' : 'less'}</span> than you thought on issues related to {topic}.</li>
                    {/* <li>On average <span className="highlight-primary">Democrats agree {formatPercent(democratsDiff)} {democratsDiff > 0 ? 'more' : 'less'}</span> than you thought on issues related to {topic}.</li>
                    <li>On average <span className="highlight-secondary">Republicans agree {formatPercent(republicansDiff)} {republicansDiff > 0 ? 'more' : 'less'}</span> than you thought on issues related to {topic}.</li> */}
                </ul>
                {/* <h5 className="text-center mt-5">Question Breakdown</h5>
                {game[topic].questions.map((question, i) => <ResultRow key={i} i={i} question={question} answer={save[topic].answers[i]} />)} */}

                {/* <h5 className="mt-5">Try a Policymaking Simulation</h5>
                <p>Interested in learning about the process your representatives go through in making policy decisions? Try a <a href="https://vop.org/policymaking-simulations/" target="_blank" rel="noopener noreferrer">Policymaking Simulation</a>.</p> */}

                <div className="text-center mt-3">
                    <LinkButton
                        to={`/topic/${topic}/0`}
                        variant="light"
                        size="lg"
                        className="mb-2 me-2"
                        onClick={() => {
                            save[topic].onQuestion = 0;
                            save[topic].onPart = 0;
                            save[topic].onResults = false;
                            for (let i = 0; i < save[topic].answers.length; i++) {
                                save[topic].answers[i] = {
                                    youAgree: null,
                                    americansAgree: null,
                                    democratsAgree: null,
                                    republicansAgree: null,
                                }
                            }
                            gameContext.updateSave({ save });
                        }}>
                        <ArrowClockwise /> Retry
                    </LinkButton>
                    <LinkButton
                        to="/"
                        variant="light"
                        size="lg"
                        className="mb-2 me-2"
                    >
                        <ListStars /> Topics
                    </LinkButton>
                </div>
                <div className="text-center">
                    {/* Reminder to check Twitter and Facebook work correctly as I don't have those accounts to test */}
                    <Popup content={
                        <>
                            <EmailShareButton
                                className='me-1'
                                subject={quote}
                                url={url}
                            >
                                <EmailIcon round size={'3rem'} />
                            </EmailShareButton>
                            <FacebookShareButton
                                className='me-1'
                                quote={quote}
                                url={url}
                                hashtag={hashtag}
                            >
                                <FacebookIcon round size={'3rem'} />
                            </FacebookShareButton>
                            <TwitterShareButton
                                className='me-1'
                                title={quote}
                                url={url}
                                hashtags={[hashtag]}
                            >
                                <TwitterIcon round size={'3rem'} />
                            </TwitterShareButton>
                            <RedditShareButton
                                title={quote}
                                url={url}
                            >
                                <RedditIcon round size={'3rem'} />
                            </RedditShareButton>
                        </>
                    }>
                        <Button
                            variant="primary"
                            size="lg"
                            className="mb-2 me-2"
                        >
                            <Share /> Share
                        </Button>
                    </Popup>
                </div>

                <div className='quote-container my-3'>
                    <h5 className="fw-bold text-center">Learn more</h5>
                    <p>Survey findings on what Americans think come from the <a href="https://publicconsultation.org/" target="_blank" rel="noopener noreferrer">University of Maryland's Program for Public Consultation (PPC)</a>.</p>
                </div>
            </Col>
        </>
    );
}

export default Results;

const ResultRow = props => {
    return (
        <div className="result-row">
            <h5>Question {props.i + 1}</h5>
            <h5 className="mx-auto">You {props.answer.youAgree ? 'Agreed' : 'Disagreed'}</h5>

            <Popup content={
                <>
                    <p>{props.question.statement}</p>
                    <hr />
                    <p><strong>You think {props.answer.americansAgree}% of Americans agree.</strong></p>
                    <p><strong>{props.question.americansAgree}% of Americans agree.</strong></p>
                </>
            }><Pie color="var(--bs-info)" percent={props.question.americansAgree} size="30" /></Popup>

            <Pie color="var(--bs-primary)" className="ms-2" percent={props.question.democratsAgree} size="30" />
            <Pie color="var(--bs-secondary)" className="ms-2" percent={props.question.republicansAgree} size="30" />
        </div>
    );
}

const Popup = props => {
    return (
        <OverlayTrigger
            // trigger={['hover', 'focus']}
            trigger="focus"
            placement="top"
            overlay={
                <Popover>
                    <Popover.Body>
                        {props.content ?? <></>}
                    </Popover.Body>
                </Popover>
            }
        >
            {/* <div style={{ display: 'flex' }}>{props.children}</div> */}
            {props.children}
        </OverlayTrigger>
    );
}
